// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__338zQ","cell":"ColumnAccessor_cell__1nvsr","firstCellAccent":"ColumnAccessor_firstCellAccent__15RNI"};